"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = require("../index");
var inputs_1 = require("../../../components/formsets/inputs");
var check_1 = tslib_1.__importDefault(require("../check"));
var vendor_1 = tslib_1.__importDefault(require("../../system/vendor"));
var state_1 = tslib_1.__importDefault(require("../../system/state"));
// @todo
// /aps/{pk}/void_reissue
// /aps/{pk}/void_credit
// /aps/{pk}/check_reverse_manual_reissue
var AccountsPayableResource = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsPayableResource, _super);
    function AccountsPayableResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountsPayableResource.related = function () {
        return Object.assign({}, index_1.BaseTransactionResource.related(), {
            vendor: vendor_1.default,
            state: state_1.default
        });
    };
    AccountsPayableResource.quote = function (apResources) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ids, response, body, resources;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ids = apResources.map(function (idOrResource) {
                            if (idOrResource instanceof index_1.BaseTransactionResource) {
                                return idOrResource.id;
                            }
                            else {
                                return idOrResource;
                            }
                        });
                        return [4 /*yield*/, this.client.get("/runs/quote?ap__id__in=" + ids.join(','))];
                    case 1:
                        response = _a.sent();
                        body = response.data;
                        resources = [];
                        if (Array.isArray(body) && body.length) {
                            body.map(function (quoteAttrs) {
                                resources.push(new check_1.default(quoteAttrs));
                            });
                        }
                        return [2 /*return*/, resources];
                }
            });
        });
    };
    AccountsPayableResource.endpoint = '/aps';
    AccountsPayableResource.MODEL_NAME = 'accountspayable';
    AccountsPayableResource.LINE_CLASS = require('./lines').default;
    AccountsPayableResource.defaultFormset = {
        number: new inputs_1.inputs.DefaultInput('Number'),
        vendor: new inputs_1.inputs.PrimaryKeyInput('Vendor', 'name'),
        amount_decimal: new inputs_1.inputs.CurrencyInput('Amount'),
        date: new inputs_1.inputs.DateInput('Date'),
        description: new inputs_1.inputs.DefaultInput('Description'),
        status: new inputs_1.inputs.EnumeratedInput('Status', [
            new inputs_1.inputs.EnumeratedInputOptionGroup('Pre-Statuses', [
                new inputs_1.inputs.EnumeratedInputOption('DRAFT'),
                new inputs_1.inputs.EnumeratedInputOption('OPEN'),
                new inputs_1.inputs.EnumeratedInputOption('AUDITED'),
            ]),
            new inputs_1.inputs.EnumeratedInputOptionGroup('GL-Statuses', [
                new inputs_1.inputs.EnumeratedInputOption('POSTED'),
                new inputs_1.inputs.EnumeratedInputOption('CLOSED'),
                new inputs_1.inputs.EnumeratedInputOption('VOIDED'),
            ]),
        ]),
    };
    return AccountsPayableResource;
}(index_1.BaseTransactionResource));
exports.default = AccountsPayableResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/ap/index.js
// module id = aYqJ
// module chunks = 0